import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import ctaBg from "@/assets/cta-bg.jpg";
import luxuryTour from "@/assets/luxury-home-tour.mp4.asset.json";

const FinalCTA = () => {
  return (
    <section className="relative py-12 md:py-16 px-6 text-center overflow-hidden">
      {/* Background luxury home tour video */}
      <video
        src={luxuryTour.url}
        poster={ctaBg}
        autoPlay
        loop
        muted
        playsInline
        preload="auto"
        className="absolute inset-0 w-full h-full object-cover"
      />
      {/* Dark overlay for text legibility */}
      <div className="absolute inset-0 bg-black/60" />

      <div className="relative z-10 max-w-[600px] mx-auto">
        <h2
          className="text-3xl md:text-[40px] font-bold text-white mb-4"
          style={{ lineHeight: '1.2', letterSpacing: '-0.5px' }}
         >
          You're not alone in this.
          <br />
          You just keep more of what's yours.
        </h2>
        <p className="text-base md:text-lg text-white/75 leading-relaxed mb-8">
          Thousands of sellers and buyers have already made the switch — full support through every step, without the 3–6% commission that eats your equity alive. Two minutes to start. Nothing to lose.
        </p>

        <div className="flex flex-wrap gap-3 justify-center">
          <Link to="/list-property">
            <Button
              size="lg"
              className="bg-accent hover:bg-brand-amber-100 text-accent-foreground font-semibold px-8 py-4 text-base rounded-xl transition-all duration-200 active:scale-[0.97]"
            >
              List my home — free to start
            </Button>
          </Link>
          <Link to="/listings">
            <Button
              size="lg"
              variant="outline"
              className="border-2 border-white bg-white text-foreground hover:bg-white/90 font-medium px-8 py-4 text-base rounded-xl transition-all duration-200 active:scale-[0.97]"
            >
              Search homes on REALV3
            </Button>
          </Link>
        </div>

        <p className="text-xs text-white/50 mt-5">
          We're with you from listing to closing. No agent fees. No contracts. No going it alone.
        </p>
      </div>
    </section>
  );
};

export default FinalCTA;
